import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import invoiceApi from '../../api/invoice.api';
import {
  PageContainer,
  LoadingContainer,
  ErrorContainer,
  PDFContainer,
} from './InvoicePDFPage.style';
import Loading from '../../components/Loading/Loading';

const InvoicePDFPage = ({match, history}) => {
  const {auth} = useSelector(state => ({auth: state.auth}));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const goBackToReports = () => history.push('/reports');
  useEffect(() => {
    if (auth) {
      fetchAndDisplayInvoice();
    }
  }, [auth]);

  const fetchAndDisplayInvoice = async () => {
    const invoiceId = match.params.invoiceId;
    if (!invoiceId) {
      setLoading(false);
      setError('Invoice ID is required');
      return;
    }

    if (!auth || !auth.access_token) {
      setLoading(false);
      setError('You must be logged in to view invoices');
      return;
    }

    try {
      const headers = {
        Authorization: `Bearer ${auth.access_token}`,
      };

      console.info(`Fetching invoice PDF ${invoiceId}`);

      // Fetch the PDF blob directly
      const pdfBlob = await invoiceApi.getInvoicePdf(invoiceId, headers);

      if (!pdfBlob) {
        throw new Error('Invoice PDF not found');
      }

      // Create blob URL and display PDF
      displayPdf(pdfBlob);
    } catch (err) {
      console.error('Error fetching invoice:', err);
      setLoading(false);
      setError(err.message || 'Failed to load invoice');
    }
  };

  const displayPdf = blob => {
    try {
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_self');
      setLoading(false);
      setPdfUrl(blobUrl);
    } catch (err) {
      console.error('Error displaying PDF:', err);
      setLoading(false);
      setError(err.message || 'Failed to display PDF');
    }
  };

  if (loading) {
    return (
      <PageContainer>
        <LoadingContainer>
          <Loading isLight={false} />
        </LoadingContainer>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <ErrorContainer>
          <h2>Error Loading Invoice</h2>
          <p>{error}</p>
          <button onClick={goBackToReports}>Go to Report</button>
        </ErrorContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PDFContainer>
        <p>Invoice is downloading...</p>
        <button onClick={goBackToReports}>Back to My Report</button>
      </PDFContainer>
    </PageContainer>
  );
};

InvoicePDFPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default InvoicePDFPage;
